<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <app-buyer-supplier-chat
    [headerData]="headerData"
    [isOpen]="isChatOpen"
    [rfqId]="headerData?.serviceRfqId"
    [userId]="userIdAsString"
    [isSupplier]="false"
    (close)="closeChat()"
  ></app-buyer-supplier-chat>

  <div class="title-text">Service Request For Quotation</div>
  <div class="section">
    <div class="search-filter-container">
      <div class="search-container">
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search on Service RFQ number, Vessel Name, Port Name and Keywords"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button *ngFor="let status of filterStatuses; let i = index" class="status-btn"
        [ngClass]="{ active: activeIndexes.includes(i) }" (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}">
        {{ status.name }}
      </button>

      <!-- RFQ Type Switcher Dropdown -->
      <div class="rfq-type-dropdown" style="margin-left: auto;">
        <button class="status-btn rfq-type-btn" [ngClass]="{ active: true }" (click)="toggleRfqTypeDropdown()">
          Service RFQ <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">arrow_drop_down</mat-icon>
        </button>
        <div class="dropdown-menu rfq-type-menu" *ngIf="rfqTypeDropdownOpen">
          <button class="dropdown-item" (click)="navigateToRfqType('product'); toggleRfqTypeDropdown()">
            Product RFQ
          </button>
          <button class="dropdown-item active-item" (click)="toggleRfqTypeDropdown()">
            Service RFQ
          </button>
        </div>
      </div>
    </div>

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedRfq.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedRfq.length }} of
          {{ this.totalRecords }} Service RFQs</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="rfqOperation('archive')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          (click)="downloadDocumentDataExcel()"
          matTooltip="Export All"
          matTooltipPosition="below"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
      </div>
      <div
        style="
          width: 7%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="invitebutton-container">
          <button
            class="circle-button"
            [matMenuTriggerFor]="usermenu"
            matTooltip="Invite User"
            (click)="onUserMenuOpened()"
          >
            <mat-icon class="icon-person"> person_add </mat-icon>
          </button>

          <mat-menu #usermenu="matMenu" id="usermenu">
            <div class="menu-content" (scroll)="onScroll()">
              <button
                mat-menu-item
                *ngFor="let item of buyerUsersList"
                (click)="toggleUserSelection(item)"
              >
                <mat-checkbox [checked]="item.selected">{{
                  item.firstName
                }}</mat-checkbox>
              </button>

              <mat-progress-spinner
                *ngIf="isLoading"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            </div>
          </mat-menu>
        </div>
        <div>
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of items"
              (click)="toggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #buyerTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        [rowIdentity]="rowIdentity"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        <!-- select rfq -->
        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedRfq.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <input
              type="checkbox"
              [checked]="isChecked(row.serviceRfqId, 'active')"
              (change)="
                selectDeselectRfq(
                  $event,
                  row.serviceRfqDetailsId,
                  row.serviceRfqId,
                  'active',
                  row.assignedUsers
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>

        <!-- Service RFQ Reference -->
        <ngx-datatable-column name="Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="rfq-reference"
              matTooltip="{{ row.serviceRfqRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.serviceRfqDetailsId)"
              >{{ row.serviceRfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Vessel -->
        <ngx-datatable-column name="Vessel" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              matTooltip="{{ row.vesselName }}"
              matTooltipPosition="below"
              >{{ row.vesselName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Port Name -->
        <ngx-datatable-column name="Port Name" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Total Suppliers -->
        <ngx-datatable-column name="Total Suppliers" [flexGrow]="0.7">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              matTooltip="{{ row.totalSuppliers }} supplier(s)"
              matTooltipPosition="below"
              >{{ row.totalSuppliers || 0 }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- Status -->
        <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill"
              matTooltip="{{ row.docStatus }}"
              matTooltipPosition="below"
              [ngStyle]="{ color: row.statusColor }"
            >
              {{ row.docStatus }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Quote Before Date -->
        <ngx-datatable-column name="Quote Before Date" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span class="Quote Before Date">
              {{ row.quotedByDate | date : "dd/MM/yyyy" }}
            </span>
            <span
              [ngStyle]="{ color: row.remainingQuote?.color }"
              style="display: block"
            >
              {{ row.remainingQuote?.tooltip }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- RFQ Created Date -->
        <ngx-datatable-column name="Service RFQ Created Date" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              matTooltip="{{ row.serviceRfqDate | date : 'dd/MM/yyyy' }}"
              matTooltipPosition="below"
            >
              {{ row.serviceRfqDateFormatted }}
            </span>
            <span
              [ngStyle]="{ color: row.remaining?.color }"
              style="display: block"
            >
              {{ row.remaining?.label }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- Dynamic Columns -->
        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span *ngIf="column.label === 'Owner'">
              <span
                *ngIf="row.assignedUsers"
                matTooltip="{{ row.assignedUsers }}"
                matTooltipPosition="below"
              >
                {{ row.assignedUserCount > 1 ? (row.assignedUsers.split(',')[0].trim() + ' +' + (row.assignedUserCount - 1) + ' more') : row.assignedUsers }}
              </span>
              <span
                *ngIf="!row.assignedUsers"
                matTooltip="No users assigned"
                matTooltipPosition="below"
              >
                -
              </span>
            </span>

            <span *ngIf="column.label !== 'Owner'">
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || "-" }}
              </span>
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- ATT/Print/Download -->
        <ngx-datatable-column
          name="ATT/Print/Download"
          [resizeable]="true"
          [sortable]="false"
          [flexGrow]="0"
          [minWidth]="170"
          [maxWidth]="200"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div class="action-buttons-container">
              <button
                mat-icon-button
                color="primary"
                matTooltip="Attachments"
                matTooltipPosition="below"
                (click)="togglePreview(true, row)"
              >
                <mat-icon>attach_file</mat-icon>
              </button>

              <span
                [matTooltip]="
                  row.docStatus === 'Draft'
                    ? 'Printing is disabled for Draft Service RFQ.'
                    : 'Print'
                "
                matTooltipPosition="below"
              >
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="row.docStatus === 'Draft'"
                  (click)="downloadRfq(row.serviceRfqDetailsId, row.serviceRfqRefNumber)"
                >
                  <mat-icon>print</mat-icon>
                </button>
              </span>

              <span
                [matTooltip]="
                  row.docStatus === 'Draft'
                    ? 'Download is disabled for Draft Service RFQ.'
                    : 'Download'
                "
                matTooltipPosition="below"
              >
                <button
                  mat-icon-button
                  color="primary"
                  [disabled]="row.docStatus === 'Draft'"
                  (click)="generateRFQExcelForBuyer(row.serviceRfqId, row.serviceRfqRefNumber)"
                >
                  <mat-icon>download</mat-icon>
                </button>
              </span>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <!-- Toggle Expand Button Column -->
        <!-- <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="65"
          [minWidth]="65"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            <mat-icon
              class="live-status-button"
              (click)="toggleExpandedRow(row)"
              matTooltip="Live status"
            >
              {{ expandedQuoteId === row.id ? "expand_less" : "expand_more" }}
            </mat-icon>
            <div
              [style.height.px]="
                !row.suppliers || row.suppliers.length === 0
                  ? 266
                  : row.suppliers.length > 3
                  ? 480
                  : row.suppliers.length * 120 + 266
              "
              style="width: 1px"
              *ngIf="expandedQuoteId === row.id"
            ></div>
            
            <div
              class="status-tracker-main-container"
              *ngIf="expandedQuoteId === row.id"
            >
              <div class="expanded-status-row">
                <div class="status-timeline-container">
                  
                  <div class="timeline-box">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div class="timeline-stage" >
                        <div class="stage-header">
                           <span class="stage-label">
                            {{ stage.label }}
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="timeline-box-footer">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages; let i = index"
                    >
                      <div
                        class="timeline-stage-footer"
                      >
                        <div
                          class="stage-point"
                          [ngClass]="[
                            getStageColorClass(stage.label,row),
                            'animate-point',
                            getCompleteIncompleteClass(stage)
                          ]"
                          [style.animationDelay]="i * 1.2 + 's'"
                        ></div>
                        <div
                          *ngIf="i < row.statusesStages.length - 1"
                          class="timeline-line animate-line"
                          [ngClass]="[getStageColorClass(stage.label,row),getCompleteIncompleteClass(stage)]"
                          [style.animationDelay]="i * 1.2 + 0.6 + 's'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="timeline-box-header">
                    <div
                      class="timeline-box-in"
                      *ngFor="let stage of row.statusesStages"
                    >
                      <div
                        class="timeline-stage-header"
                      >
                        <div class="stage-header-up">
                          <span class="stage-date">{{ stage.date }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                  

                  
                  <div
                    class="arrow-text alert alert-danger"
                    style="width: 870px; margin-top: 14px; margin-left: 6px"
                    *ngIf="row?.suppliers?.length === 0"
                  >
                    No suppliers found
                  </div>

                  <div class="table-actions" *ngIf="row?.suppliers?.length > 0">
                    <button
                      class="chip-btn"
                      (click)="onReminderClick(row)"
                      [disabled]="selectedSupplierForReminders.length === 0"
                    >
                      Reminder {{ selectedSupplierForReminders.length }}/{{
                        row?.suppliers?.length || 0
                      }}
                    </button>
                  </div>

                  <div
                    class="supplier-table-container"
                    *ngIf="row?.suppliers?.length > 0"
                  >
                    <table class="supplier-table">
                      <thead>
                        <tr style="background-color: #44796f">
                          <th style="width: 63px">
                            <mat-checkbox
                              [(ngModel)]="masterSelected"
                              (change)="selectAllSuppliers(row.suppliers)"
                            ></mat-checkbox>
                          </th>
                          <th>Supplier Name</th>
                          <th>Response Time</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let supplier of row.suppliers">
                          <td>
                            <mat-checkbox
                              [(ngModel)]="supplier.selected"
                              (change)="checkIfAllSelected(row.suppliers)"
                            ></mat-checkbox>
                          </td>

                          <td>
                            <span class="supplier-name">{{
                              supplier.supplierName || "N/A"
                            }}</span>
                          </td>

                          <td>
                            {{
                              supplier.responseTime
                                ? formatDate(supplier.responseTime)
                                : "N/A"
                            }}
                          </td>

                          <td>
                            {{ getSupplierStatus(supplier) }}
                          </td>

                          <td>
                            <button
                              *ngIf="supplier.rfqStatus === 3 || supplier.quoteStatus === 3"
                              mat-icon-button
                              color="primary"
                              matTooltip="View Quote"
                              (click)="openRfqDetails(row.serviceRfqDetailsId)"
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>

                            <button
                              mat-icon-button
                              color="primary"
                              matTooltip="Supplier Contact Details"
                              matTooltipPosition="below"
                              (click)="toggleContactPopUp(true, supplier)"
                            >
                              <mat-icon>local_phone</mat-icon>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column> -->

        <!-- Action -->
        <ngx-datatable-column name="Action" [minWidth]="100" [flexGrow]="2">
          <ng-template let-column="column" ngx-datatable-header-template
            ><span>Action</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button
              *ngIf="row.docStatus === 'Cancelled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              matTooltip="Preview"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.serviceRfqDetailsId)"
            >
              <mat-icon>visibility</mat-icon>
            </button>

            <button
              *ngIf="row.docStatus !== 'Cancelled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openRfqDetails(row.serviceRfqDetailsId)"
              matTooltip="Open"
              matTooltipPosition="below"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              *ngIf="row.docStatus !== 'Cancelled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openCancellationBox(row.serviceRfqId)"
              matTooltip="Cancel Service RFQ"
              matTooltipPosition="below"
            >
              <mat-icon color="warn" *ngIf="row.docStatus != 'Draft'">cancel</mat-icon>
              <mat-icon color="warn" *ngIf="row.docStatus === 'Draft'">delete</mat-icon>
            </button>

            <button
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1 chat-btn"
              [matBadge]="row.chatCount"
              [matBadgeHidden]="!row.chatCount"
              matBadgePosition="below after"
              matBadgeSize="small"
              matBadgeColor="primary"
              matTooltip="Chat"
              matTooltipPosition="below"
            >
              <mat-icon>chat</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedRfq.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedRfq.length }} of
              {{ this.archivedTotalRecords }} archived Service RFQs</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Unarchive"
            matTooltipPosition="below"
            (click)="rfqOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div>

        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="archivedMenu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #archivedMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>

        <ngx-datatable
          style="border-radius: 5px"
          #archivedSection
          #archivedTable
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="limit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          [rowIdentity]="rowIdentity"
          (page)="onArchivedPageChange($event)"
          (sort)="onSort($event)"
          [rowClass]="setRowClass"
        >
          <!-- Service RFQ Reference -->
          <ngx-datatable-column name="Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="rfq-reference"
                matTooltip="{{ row.serviceRfqRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.serviceRfqDetailsId)"
                >{{ row.serviceRfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Vessel -->
          <ngx-datatable-column name="Vessel" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{ row.vesselName }}"
                matTooltipPosition="below"
                >{{ row.vesselName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Port Name -->
          <ngx-datatable-column name="Port Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Total Suppliers -->
          <ngx-datatable-column name="Total Suppliers" [flexGrow]="0.7">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{ row.totalSuppliers }} supplier(s)"
                matTooltipPosition="below"
                >{{ row.totalSuppliers || 0 }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="status-pill"
                matTooltip="{{ row.docStatus }}"
                matTooltipPosition="below"
                [ngStyle]="{ color: row.statusColor }"
              >
                {{ row.docStatus }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- RFQ Created Date -->
          <ngx-datatable-column
            name="Service RFQ Created Date"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{ row.serviceRfqDate | date : 'dd/MM/yyyy' }}"
                matTooltipPosition="below"
              >
                {{ formatRfqDate(row.serviceRfqDate) }}
              </span>
              <span
                [ngStyle]="{ color: row.remaining?.color }"
                style="display: block"
              >
                {{ row.remaining?.label }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Quote Before Date -->
          <ngx-datatable-column name="Quote Before Date" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="Quote Before Date">
                {{ row.quotedByDate | date : "dd/MM/yyyy" }}
              </span>
              <span
                [ngStyle]="{ color: row.remainingQuote?.color }"
                style="display: block"
              >
                {{ row.remainingQuote?.tooltip }}
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Dynamic Columns -->
          <ngx-datatable-column
            *ngFor="let column of archivedSelectedColumns"
            [name]="column.label"
            [flexGrow]="1"
          >
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span *ngIf="column.label === 'Owner'">
                <span
                  *ngIf="row.assignedUsers"
                  matTooltip="{{ row.assignedUsers }}"
                  matTooltipPosition="below"
                >
                  {{ row.assignedUserCount > 1 ? (row.assignedUsers.split(',')[0].trim() + ' +' + (row.assignedUserCount - 1) + ' more') : row.assignedUsers }}
                </span>
                <span
                  *ngIf="!row.assignedUsers"
                  matTooltip="No users assigned"
                  matTooltipPosition="below"
                >
                  -
                </span>
              </span>

              <span *ngIf="column.label !== 'Owner'">
                <span
                  *ngIf="isDate(row[column.prop])"
                  matTooltip="{{
                    row[column.prop] | date : 'dd/MM/yyyy' : '-'
                  }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
                </span>
                <span
                  *ngIf="!isDate(row[column.prop])"
                  matTooltip="{{ row[column.prop] || '-' }}"
                  matTooltipPosition="below"
                >
                  {{ row[column.prop] || "-" }}
                </span>
              </span>
            </ng-template>
          </ngx-datatable-column>

          <!-- Restore Action -->
          <ngx-datatable-column name="Action" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                class="popover_delete"
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="Restore"
                  matTooltipPosition="below"
                  >restore</mat-icon
                >
              </button>

              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover popover-card">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title class="popover-title"
                      >Are you sure?</mat-card-title
                    >
                  </mat-card-header>
                  <mat-card-actions
                    class="mat-card-action-popover popover-actions"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                      (click)="popoverTrigger.togglePopover()"
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action restore"
                      mat-raised-button
                      color="warn"
                      (click)="RestoreRfq(true, row)"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>
    </div>

    <!-- Popup for confirmation -->
    <div class="namemodal" *ngIf="showConfirmationDialogue">
      <div class="modalContent">
        <div class="p-6 text-center">
          <div class="flex justify-center mb-4">
            <div
              class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
            >
              <mat-icon
                class="text-orange-600"
                style="font-size: 40px; height: 100%; width: 100%"
                >warning</mat-icon
              >
            </div>
          </div>
          <p class="mb-6">
            Are you sure you want to
            {{ selectedRfqStatus === 'Draft' ? 'delete' : 'cancel' }}
            this {{ selectedRfqStatus === 'Draft' ? 'draft' : '' }} Service RFQ?<br />
            This action is permanent and can not be undone.<br />Select
            a reason from the dropdown
          </p>
          <mat-form-field class="full-width" color="accent">
            <mat-label> {{ selectedRfqStatus === 'Draft' ? 'Delete' : 'Cancel' }} reason</mat-label>
            <mat-select [(ngModel)]="cancelReason">
              <mat-option value="No Longer Needed">
                No Longer Needed</mat-option
              >
              <mat-option value="Duplicate RFQ"> Duplicate RFQ</mat-option>
              <mat-option value="Error in the RFQ Details">
                Error in the RFQ Details</mat-option
              >
              <mat-option value="Supplier Information not available">
                Supplier Information not available</mat-option
              >
              <mat-option value="Other"> Other</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Input field for custom reason when "Other" is selected -->
          <mat-form-field
            *ngIf="cancelReason === 'Other'"
            class="full-width"
            color="accent"
          >
            <mat-label>Specify the reason</mat-label>
            <input
              matInput
              [(ngModel)]="customReason"
              placeholder="Please specify"
            />
          </mat-form-field>
          <div class="flex justify-center gap-4">
            <button
              mat-raised-button
              color="primary"
              (click)="save(true)"
              [disabled]="
                cancelReason == '' ||
                (cancelReason === 'Other' && customReason.trim() === '')
              "
            >
              Yes, Cancel
            </button>
            <button mat-stroked-button (click)="cancelDialog()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-contact-details
  [showContactPopup]="showContactPopup"
  [contactData]="selectedSupplier"
  (close)="showContactPopup = false">
</app-contact-details>

<app-document-preview
  [previewDocs]="previewDocs"
  [showPopup]="previewSection"
  (close)="previewSection = false">
</app-document-preview>
